// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/introduction/introduction.scss
 ** module id = 145
 ** module chunks = 0 1
 **/